<template>
  <div v-if="selectedClassRoom">


    <v-toolbar flat dark color="primary">

      <v-toolbar-title class="text.center">Attendance: {{ selectedClassRoom.ClassRoom.name }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="$router.go(-1)">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <!-- <v-toolbar-items>
          <v-btn dark text @click="dialog = false">
            Update
          </v-btn>
        </v-toolbar-items> -->
    </v-toolbar>

    <v-container grid-list-md pb-0>
      <DateTimePicker v-if="dateTime" :range="true" defaultRange="thisMonth" v-model="dateTime"
        :initStartDate="dateTime.start" :initEndDate="dateTime.end" />
      <v-card outlined class="rounded-lg mt-5">
        <v-card-text>
          <v-layout row wrap>
            <v-flex class="text-h6">Students</v-flex>
            <v-spacer></v-spacer>
            <!-- <v-flex shrink v-if="Students.length">
              <v-btn elevation="0" small @click="addStudent" color="success">Add</v-btn>
            </v-flex> -->
          </v-layout>
          <v-list v-if="Attendance" class="view-container" :dense="$vuetify.breakpoint.xsOnly">
            <template v-for="(item, index) in Attendance">

              <v-list-item :key="item.fullName">
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold text-capitalize">{{ item.fullName }}
                  </v-list-item-title>

                  <v-list-item-subtitle class="text-capitalize">
                    <span>{{ item.totalAttendance }} Attendance Taking</span>
                  </v-list-item-subtitle>

                  <v-list-item-subtitle class="text-capitalize" >
                    <span>{{ item.totalPresentAttendance }} Present</span> <span
                      v-if="item.totalAbsentAttendance !== 0"> | {{ item.totalAbsentAttendance }} Absent</span> <span
                      v-if="item.totalLateAttendance !== 0"> | {{ item.totalLateAttendance }} Late</span> <span
                      v-if="item.totalLeaveAttendance !== 0"> | {{ item.totalLeaveAttendance }} Leave</span>
                  </v-list-item-subtitle>

                  <!-- <v-list-item-subtitle v-if="item.femaleStudentLeads !== 0">{{ item.femaleStudentLeads }} - Female
                  </v-list-item-subtitle> -->


                </v-list-item-content>
                <v-list-item-action>

                  <!-- <v-list-item-title v-if="item.Student.Customer && item.Student.Customer.phoneNumber">{{
                            item.Student.Customer.phoneNumber | USPhoneNumber
                        }}</v-list-item-title> -->


                  <v-progress-circular :size="35" :width="3" :value="item.per" color="teal">
                    <span class="caption">{{ item.per }}</span>
                  </v-progress-circular>
                </v-list-item-action>
              </v-list-item>

              <v-divider v-if="index < Attendance.length - 1" :key="index"></v-divider>
            </template>

          </v-list>
        </v-card-text>
      </v-card>

    </v-container>


    <BottomNavigation />

  </div>

</template>

<script>
import DateTimePicker from '@/components/DateTimePicker.vue';
import { mapActions, mapGetters } from 'vuex'
import attService from '@/modules/TeacherModules/Attendance/service.js'
import BottomNavigation from "@/modules/TeacherModules/Layout/components/BottomNavigation.vue";

export default {
  name: 'att-report',
  data() {
    return {
      // start: this.$moment()
      //   .startOf("month")
      //   .toISOString(),
      // end: this.$moment()
      //   .endOf("month")
      //   .toISOString(),
      Attendance: null,
      dateTime: {
        start: this.$moment()
          .startOf("month")
          .toISOString(),
        end: this.$moment()
          .endOf("month")
          .toISOString()
      },
    }
  },
  components: {
    DateTimePicker,
    BottomNavigation,
  },
  created() {
    if (!this.selectedClassRoom) {
      this.$router.push({ path: '/t' })
    } else {
      this.getAttendance()
    }
  },
  watch: {
    dateTime() {
      this.getAttendance()
    }
  },
  computed: {
    ...mapGetters("teacherLayout", ["getClassRoom", "getTeacherStore"]),
    selectedClassRoom: {
      get() {
        return this.getClassRoom
      },
      set(val) {
        this.setClassRoom(val)
      }
    },
    Teacher: {
      get() {
        return this.getTeacherStore
      },
      set(val) {
        this.setTeacher(val)
      }
    },
  },
  methods: {
    ...mapActions("teacherLayout", ['setClassRoom', 'setTeacher']),
    getAttendance() {
      const where = {
        start: this.dateTime.start,
        end: this.dateTime.end,
        ClassRoomId: this.selectedClassRoom.ClassRoomId
      }
      console.log('where', where)
      return attService.attendanceInfo(where)
        .then(response => {
          console.log('response attendanceInfo', response)


          this.Attendance = response.data
          this.Attendance.map(row => {
            row.per = ((row.totalPresentAttendance + row.totalLateAttendance + row.totalLeaveAttendance) / row.totalAttendance) * 100
            if (isNaN(parseInt(row.per))) {
              row.per = 0
            } else {
              row.per = parseInt(row.per)
            }

          })




        })
    },
  }
}
</script>

<style scoped>
.view-container {
  height: calc(100vh - 270px);
  width: 100%;
  overflow: auto;
}
</style>